/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetOrganizationsIdQueryResponse,
  GetOrganizationsIdPathParams,
  GetOrganizationsId404,
} from "../types/GetOrganizationsId.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOrganizationsIdQueryKey = (
  id: GetOrganizationsIdPathParams["id"] | undefined,
) => [{ url: "/organizations/:id", params: { id: id } }] as const;

export type GetOrganizationsIdQueryKey = ReturnType<
  typeof getOrganizationsIdQueryKey
>;

/**
 * @description Примеры:
 * - GET /organizations/123e4567-e89b-12d3-a456-426614174000
 * - GET /organizations/glt-esports
 * @summary Получение информации об организации по ID или URL (slug)
 * {@link /organizations/:id}
 */
export async function getOrganizationsId(
  id: GetOrganizationsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetOrganizationsIdQueryResponse,
    ResponseErrorConfig<GetOrganizationsId404>,
    unknown
  >({ method: "GET", url: `/organizations/${id}`, ...requestConfig });
  return res;
}

export function getOrganizationsIdQueryOptions(
  id: GetOrganizationsIdPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getOrganizationsIdQueryKey(id);
  return queryOptions<
    ResponseConfig<GetOrganizationsIdQueryResponse>,
    ResponseErrorConfig<GetOrganizationsId404>,
    ResponseConfig<GetOrganizationsIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getOrganizationsId(id!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Примеры:
 * - GET /organizations/123e4567-e89b-12d3-a456-426614174000
 * - GET /organizations/glt-esports
 * @summary Получение информации об организации по ID или URL (slug)
 * {@link /organizations/:id}
 */
export function useGetOrganizationsId<
  TData = ResponseConfig<GetOrganizationsIdQueryResponse>,
  TQueryData = ResponseConfig<GetOrganizationsIdQueryResponse>,
  TQueryKey extends QueryKey = GetOrganizationsIdQueryKey,
>(
  id: GetOrganizationsIdPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetOrganizationsIdQueryResponse>,
        ResponseErrorConfig<GetOrganizationsId404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getOrganizationsIdQueryKey(id);

  const query = useQuery(
    {
      ...getOrganizationsIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetOrganizationsId404>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
